<template>
  <div class="pt-3 px-3 pb-1">

    <div v-if="!user.bank_account_holder" class="text-center">
      <p><a href="/profile/edit-banking"><i class="fa-solid fa-circle-plus mr-1"></i>Add banking details</a></p>
      <p>Service providers and affiliates are paid every week</p>
    </div>

    <div v-else class="px-3 pb-3">
      <div class="row">
          <div class="col-md-3">
          <label class="form-label" for="fullname">Account Holder</label>
          <div>{{user.bank_account_holder}}</div>
          </div>
          <div class="col-md-3">
          <label class="form-label" for="dealer-name">ACH Number</label>
          <div>{{user.bank_ach_number}}</div>
          </div>
      </div>

      <div class="row mt-2">
          <div class="col-md-3">
          <label class="form-label" for="fullname">Account Number</label>
          <div>{{user.bank_account_number}}</div>
          </div>
          <div class="col-md-3">
          <label class="form-label" for="dealer-name">Account Type</label>
          <div>Checking</div>
          </div>
      </div>

      <div class="row mt-2">
          <div class="col-md-3">
          <label class="form-label" for="fullname">Currency</label>
          <div>USD</div>
          </div>
      </div>

    </div>

    </div>
 
</template>

<script>

export default {
  props: ['user'],

  data() {
    return {

    };
  },

  created() {

},

  methods: {

  },
};
</script> 

<style scoped>
.form-label{
    font-weight: 600 !important;
}
</style>